import { Controller } from '@hotwired/stimulus';
import JSZip from 'jszip';

export default class extends Controller {
  static values = {
    url: String,
    filename: String,
  };

  async download() {
    const button = this.element;
    const originalText = button.textContent;

    try {
      button.disabled = true;
      button.textContent = 'ダウンロード準備中...';

      const response = await fetch(this.urlValue);
      if (!response.ok) {
        throw new Error('画像URLの取得に失敗しました');
      }

      const data = await response.json();
      const { images } = data;

      if (!images || images.length === 0) {
        $.notify({ message: 'ダウンロードする画像がありません' }, { type: 'warning' });
        return;
      }

      const zip = new JSZip();

      for (let i = 0; i < images.length; i++) {
        const image = images[i];
        const blob = await this.fetchImage(image.url);
        zip.file(image.filename, blob);
      }

      const zipBlob = await zip.generateAsync({ type: 'blob' });
      const filename = this.hasFilenameValue && this.filenameValue
        ? `${this.filenameValue}.zip`
        : `tour_photos_${new Date().toISOString().replace(/[:.]/g, '-').slice(0, -5)}.zip`;

      this.downloadBlob(zipBlob, filename);

      $.notify(
        { message: `${images.length}枚の写真をZIPファイルでダウンロードしました` },
        { type: 'success' },
      );
    } catch (error) {
      console.error('ダウンロードエラー:', error);
      $.notify({ message: 'ダウンロードに失敗しました' }, { type: 'danger' });
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  async fetchImage(url) {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`画像の取得に失敗しました: ${url}`);
    }
    return response.blob();
  }

  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}
